import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <div className="pt-16 lg:pt-20" data-testid="contact-page">
      <Contact />
    </div>
  );
}
